import styles from './LegalPage.module.css';

function PrivacyPage() {
  return (
    <div className={styles.legalContainer}>
      <div className="page-header">
        <h2>Privacy Policy</h2>
      </div>
      <p>
        <strong>Last Updated:</strong> August 25, 2025
      </p>

      <p>
        Welcome to the Ego Console ("Ego," "we," "us," or "our"). We are
        committed to protecting your privacy. This Privacy Policy explains how
        we collect, use, disclose, and safeguard your information when you use
        our website and services (collectively, the "Services").
      </p>
      <p>
        Please read this policy carefully. By using our Services, you agree to
        the collection and use of information in accordance with this policy.
      </p>

      <h3>1. Information We Collect</h3>
      <p>
        We may collect information about you in a variety of ways. The
        information we may collect includes:
      </p>
      <ul>
        <li>
          <strong>Personal Data:</strong> When you register, we collect
          information from your chosen social login provider (e.g., Google,
          LinkedIn), which may include your name and email address. We also
          collect any additional profile information you voluntarily provide,
          such as your date of birth, gender, and country.
        </li>
        <li>
          <strong>Persona Data:</strong> We collect all the data you provide to
          create your Digital Passport and Public Personas. This includes
          psychometric data from personality assessments, narrative data, and
          communication style preferences.
        </li>
        <li>
          <strong>Usage Data:</strong> We collect information about your
          activity on the Services, such as your plan tier, "Ego Credits" used,
          and the public engagement your personas receive.
        </li>
        <li>
          <strong>Derivative Data:</strong> Our servers automatically collect
          standard log data, such as your IP address, browser type, and access
          times.
        </li>
      </ul>

      <h3>2. How We Use Your Information</h3>
      <p>We use the information we collect to:</p>
      <ul>
        <li>Provide, operate, and maintain our Services.</li>
        <li>Create and manage your account.</li>
        <li>Generate and serve your AI personas and profiles.</li>
        <li>Process transactions and manage your subscription.</li>
        <li>Communicate with you and provide customer support.</li>
        <li>Monitor and analyze usage and trends to improve the Services.</li>
        <li>Protect against fraudulent, unauthorized, or illegal activity.</li>
      </ul>

      <h3>3. Disclosure of Your Information</h3>
      <p>
        We do not share your private Personal Data or Digital Passport data
        except in the limited circumstances described below:
      </p>
      <ul>
        <li>
          <strong>With Service Providers:</strong> We may share information with
          third-party vendors that perform services for us, such as cloud
          hosting (Amazon Web Services), authentication (Auth0), payment
          processing (Stripe), and AI model providers (OpenAI).
        </li>
        <li>
          <strong>By Law or to Protect Rights:</strong> We may disclose your
          information if required to do so by law or to protect and defend our
          rights or property.
        </li>
        <li>
          <strong>With Your Consent:</strong> We may disclose your information
          for any other purpose with your consent.
        </li>
      </ul>

      <h3>4. Data Security</h3>
      <p>
        We use administrative, technical, and physical security measures to help
        protect your personal information. While we have taken reasonable steps
        to secure the information you provide to us, please be aware that no
        security measures are perfect or impenetrable.
      </p>

      <h3>5. Your Data Rights</h3>
      <p>
        You have the right to access, correct, or delete your personal data at
        any time through your Account Settings page. If you wish to permanently
        delete your account and all associated data, you may do so from your
        settings or by contacting us.
      </p>

      <h3>6. Contact Us</h3>
      <p>
        If you have questions or comments about this Privacy Policy, please
        contact us at:{' '}
        <a href="mailto:contact@soulstore.ai">contact@soulstore.ai</a>
      </p>
    </div>
  );
}

export default PrivacyPage;
